import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "./actionCreators";
import { FetchStatus } from "../../globalConsts";

const { Uninitialized, Failed, FetchingInitial, Refetching, Fetched } =
  FetchStatus;

export type GlobalFetchPartition = "navMenu" | "homepage";

export type State = Record<GlobalFetchPartition, FetchStatus>;

const initialState: State = {
  navMenu: Uninitialized,
  homepage: Uninitialized,
};

const globalFetchReducer = reducer(
  initialState,
  on(AC.requestFetchGlobalPartition, (state, action) => {
    const { partition } = action.payload;
    const isFirstFetch = state[partition] === Uninitialized;
    state[partition] = isFirstFetch ? FetchingInitial : Refetching;
  }),

  on(AC.receiveFetchGlobalPartition, (state, action) => {
    const { partition } = action.payload;
    state[partition] = Fetched;
  }),

  on(AC.errorFetchGlobalPartition, (state, action) => {
    const { partition } = action.payload;
    state[partition] = Failed;
  })
);

export default globalFetchReducer;
export type GlobalFetchSlice = State;
